import { Chip } from '@/components/ui/chip';
import { translate } from '@/i18n';
import { decimalPrecision, formatNumberToCurrency } from '@/lib/currencyFormat';

interface ProductPriceProps {
  lowestPriceBeforeDiscount: number | null;
  price: number;
  originalPrice: number;
  classNames?: string;
  priceClassNames?: string;
  promotion?: boolean;
}

export const ProductPrice: React.FC<ProductPriceProps> = ({
  lowestPriceBeforeDiscount,
  price,
  originalPrice,
  classNames,
  priceClassNames,
  promotion
}) => {
  const discountValue = lowestPriceBeforeDiscount ? lowestPriceBeforeDiscount - price : 0;
  return (
    <div className={`flex flex-col ${classNames || ''}`}>
      {promotion && lowestPriceBeforeDiscount && (
        <>
          <div>
            <span className="inline text-xs leading-[166%] font-normal text-(--mui-palette-text-disabled)">
              {translate('lowest-price')}:{' '}
            </span>
            <span className="inline text-xs leading-[166%] font-normal text-(--mui-palette-text-disabled)">
              {formatNumberToCurrency(
                lowestPriceBeforeDiscount || 0,
                'PLN',
                'pl',
                decimalPrecision(lowestPriceBeforeDiscount)
              )}
            </span>
          </div>
          <div>
            <span className="inline text-xs leading-[166%] font-normal text-(--mui-palette-text-disabled)">
              {translate('original-price')}:{' '}
            </span>
            <span className="inline text-xs text-(--mui-palette-text-disabled)">
              {formatNumberToCurrency(
                originalPrice || 0,
                'PLN',
                'pl',
                decimalPrecision(originalPrice)
              )}
            </span>
          </div>
        </>
      )}
      <div className="flex items-center gap-2">
        <span
          className={`text-2xl font-['Manrope'] font-bold ${priceClassNames} leading-[134%] text-(--mui-palette-primary-main)`}
        >
          {formatNumberToCurrency(price || 0, 'PLN', 'pl', decimalPrecision(price))}
        </span>
        {discountValue > 0 ? (
          <Chip
            size="small"
            label={`- ${formatNumberToCurrency(
              discountValue || 0,
              'PLN',
              'pl',
              decimalPrecision(discountValue)
            )}`}
            style={{
              backgroundColor: 'var(--mui-palette-tertiary-main)',
              color: 'var(--mui-palette-tertiary-contrast)'
            }}
          />
        ) : null}
      </div>
    </div>
  );
};
